import { createContext } from "react";

export interface OpenLockDialogOptions {
  /** Skip confirmation and go directly to progress (used by auto-lock) */
  skipConfirmation?: boolean;
}

export interface LockEncryptionDialogContextType {
  /** Open the lock dialog */
  openLockDialog: (options?: OpenLockDialogOptions) => void;
  /** Whether the dialog is currently open */
  isDialogOpen: boolean;
  /** Whether locking is in progress */
  isLocking: boolean;
}

export const LockEncryptionDialogContext = createContext<LockEncryptionDialogContextType | null>(
  null
);
